import {generateCartItemKey, updateInternalCart} from "../../utils/cart";

const initialState = {
  items: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ADD_TO_CART":
      const newItem = action.payload;

      const existingCartItemIndex = state.items.findIndex( cartItem => cartItem?.uniqueKey === newItem?.uniqueKey );

      if (existingCartItemIndex !== -1) {
        // Si el ítem ya existe, actualiza la cantidad y el precio total
        const updatedItems = [...state.items];
        updatedItems[existingCartItemIndex].quantity += newItem.quantity;
        updatedItems[existingCartItemIndex].totalPrice += newItem.totalPrice;

        updateInternalCart(updatedItems)

        return {
          ...state,
          items: updatedItems,
        };
      } else {
        updateInternalCart([...state.items, newItem])
        // Si el ítem no existe, agrega uno nuevo
        return {
          ...state,
          items: [...state.items, newItem],
        };
      }

    case "UPDATE_CART_ITEM":
      const updatedItems = [...state.items];
      updatedItems[action.payload.index] = action.payload.updatedItem;

      updateInternalCart(updatedItems)

      return {
        ...state,
        items: updatedItems,
      };

    case "REMOVE_FROM_CART":
      const cartItemKeyToRemove = action.payload;
      const updatedItemsRemove = state.items.filter(
        (item) =>
          generateCartItemKey(item.item, item.selectedExtras, item?.item?.size) !==
          cartItemKeyToRemove
      );

      updateInternalCart(updatedItemsRemove)

      return {
        ...state,
        items: updatedItemsRemove,
      };

    case "CLEAR_CART":
      updateInternalCart([])
      return {
        ...state,
        items: [],
      };

    case "LOAD_ORDER_ITEMS":
      const orderItems = action.payload;
      const newItems = orderItems.map((orderItem) => {
        const uniqueKey = generateCartItemKey(
          orderItem.item,
          orderItem.selectedExtras,
          orderItem.item?.size
        );
        const existingItemIndex = state.items.findIndex(
          (item) =>
            generateCartItemKey(item.item, item.selectedExtras, item?.item?.size) === uniqueKey
        );

        if (existingItemIndex !== -1) {
          state.items[existingItemIndex].quantity += orderItem.quantity;
          state.items[existingItemIndex].totalPrice += orderItem.totalPrice;
        } else {
          state.items.push({
            item: orderItem.item,
            quantity: orderItem.quantity,
            selectedExtras: orderItem.selectedExtras,
            totalPrice: orderItem.totalPrice,
          });
        }
      });

      updateInternalCart([...state.items])

      return {
        ...state,
        items: [...state.items],
      };

    case "UPDATE_QUANTITY":
      const { uniqueKey, newQuantity } = action.payload;
      const itemToUpdateIndex = state.items.findIndex(
        (cartItem) =>
          cartItem?.uniqueKey ===
          uniqueKey
      );

      if (itemToUpdateIndex !== -1) {
        const updatedItemsUpdate = [...state.items];
        updatedItemsUpdate[itemToUpdateIndex].quantity = newQuantity;

        // Opcional: Actualizar el totalPrice si depende de la cantidad
        const itemPrice = parseFloat(
          updatedItemsUpdate[itemToUpdateIndex].item.price
        );
        const extrasPrice = updatedItemsUpdate[
          itemToUpdateIndex
        ].selectedExtras.reduce(
          (sum, extra) => sum + parseFloat(extra.price),
          0
        );
        updatedItemsUpdate[itemToUpdateIndex].totalPrice =
          (itemPrice + extrasPrice) * newQuantity;

        updateInternalCart(updatedItemsUpdate)

        return {
          ...state,
          items: updatedItemsUpdate,
        };
      } else {
        // Manejo de casos donde no se encuentra el ítem
        return state;
      }
    
    case 'SET_CART': {
      return {
        ...state,
        items: action?.payload,
      }
    }

    case 'LOGOUT': {
      return initialState;
    }
    
    default:
      // Importante: Devolver el estado actual si no se cumple ningún caso
      return state;
  }
};
